import React from 'react';
import { bool, element, oneOfType, string, func } from 'prop-types';

function NavbarItem({
  children, classLink, className, link, text, label, shouldShowModal, showExitPopup, handleClick,
}) {
  const renderLink = () => (
    <a className={classLink} href={link}>
      {!children && text}
      {children}
    </a>
  );

  const renderModal = () => (
    <span className={classLink} onClick={() => showExitPopup(link)}>
      {!children && text}
      {children}
    </span>
  );

  return (
    <li className={className} onClick={() => handleClick(label)}>
      {shouldShowModal ? renderModal() : renderLink()}
    </li>
  );
}

NavbarItem.propTypes = {
  className: string.isRequired,
  classLink: string,
  children: oneOfType([bool, element]),
  link: string,
  text: string,
  showExitPopup: func.isRequired,
  shouldShowModal: bool,
  handleClick: func.isRequired,
  label: string,
};

NavbarItem.defaultProps = {
  classLink: '',
  children: false,
  text: '',
  link: '',
  shouldShowModal: false,
  label: '',
};


export default NavbarItem;
